<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import Vue from 'vue'
export default {
  name: 'App',
  created() {
    console.log(Vue.prototype.$VUE_APP_BASE_API)
  }
}
</script>
